import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=4ecec3c8&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=4ecec3c8&prod&scoped=true&lang=css"
import style1 from "./Imprint.vue?vue&type=style&index=1&id=4ecec3c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecec3c8",
  null
  
)

export default component.exports